export function SetCustomFieldBoxViewConstructor(services, callbacks, context, siteTypeConfig) {

    let joint = services.joint;
  
    return joint.shapes.html.AbstractBoxElementView.extend({
      isElementEditable: true,
      editElementModalController: 'chooseCustomFieldBoxController',
      editElementModalTemplate: require('./chooseCustomFieldBox.modal.html'),
      angularTemplate: `
      <div layout="column">
          <span> {{elementView.boxDescription()}} </span>
      </div>
      `,

      boxDescription: function() {

        if (!this.angularScope.elementData) {
          return services.$translate.instant('parameters/quick_replies/details/add_a_custom_field');
        } else if(this.angularScope.elementData.selectedCustomField && this.angularScope.elementData.inputType==='variable') {
          return services.$translate.instant('parameters/quick_replies/details/graph/custom_field_with_variable_description',
            {
              customField: this.angularScope.elementData.selectedCustomFieldLabel,
              variable: this.angularScope.elementData.variable
            })
        } else if (this.angularScope.elementData.selectedCustomField && this.angularScope.elementData.inputType==='message') {
          return services.$translate.instant('parameters/quick_replies/details/graph/custom_field_with_message_description', {
            customField: this.angularScope.elementData.selectedCustomFieldLabel
          })
        }
      }

    });

  }
  
